import React from 'react';
import changelogData from './changelog.json';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Changelog.css';

const Changelog = () => (
    <div className="container my-4">
        <h2 className="mb-4">Changelog</h2>
        {Object.entries(changelogData).map(([date, changes]) => (
            <div key={date} className="card mb-3 shadow-sm">
                <div className="card-header bg-light d-flex justify-content-between align-items-center">
                    <h3 className="h5 mb-0">{date}</h3>
                    <p className="mb-0 text-muted">{changes.description}</p>
                </div>
                <div className="card-body">
                    <ol className="list-group list-group-flush">
                        {changes.items.map((item, index) => (
                            <li key={index} className="list-group-item border-0">
                                {item}
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        ))}
    </div>
);

export default Changelog;